/**
 * Card/users query sortable fields
 *
 * @package HOPS
 * @subpackage Cards
 * @author Heron Web Ltd
 * @copyright Heritage Operations Processing Limited
 */
const CardsUsersQuerySortField = {

	UserSname: 1,

	CardIssuedDate: 2,

	CardExpiryDate: 3,

	UserDetailsLastChecked: 4,

	ElementAwardDate: 5,

	UserDeptConfs: 6

};

export default CardsUsersQuerySortField;
